import { render, staticRenderFns } from "./NewsController.vue?vue&type=template&id=1cd3e682&scoped=true"
import script from "./NewsController.vue?vue&type=script&lang=js"
export * from "./NewsController.vue?vue&type=script&lang=js"
import style0 from "./NewsController.vue?vue&type=style&index=0&id=1cd3e682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd3e682",
  null
  
)

export default component.exports